import { RepeatCardSettingComponentProps, RepeatCardSettingComponentHandler, RepeatCardSettingComponentState } from './repeatcardsettingcomponent';
import { UIDataModel } from '../../../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import * as React from 'react';
import { RepeatCardSettingCSSStyle } from './repeatcardsettingcss';
import './repeat-card-style.css';

export class RepeatCardSettingViewImpl extends UIComponentViewImpl<UIDataModel>
{
  
    bindHandlers()
    {
        this.onClick = this.onClick.bind(this);
    }
    draw(props: RepeatCardSettingComponentProps, state: RepeatCardSettingComponentState, cssStyle: RepeatCardSettingCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div id="repeat-card-main" style={cssStyle.getInnerWrapperCSSStyle(state.isSelected)} onClick={this.onClick}>
               <label id="repeat-card-text" style={cssStyle.getTitleLabelCSSStyle(state.isSelected)}>
                    {props.title}
               </label>
            </div>
        );
    }  

    onClick()
    {
        (this.getUIComponentHandler() as RepeatCardSettingComponentHandler).onRepeatClick();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/repeatcardsetting/repeatcardsettingview.tsx